'use client'

import { Pills } from '@/components/ui/PageHeader'
import { track } from '@/lib/tracking'
import { ORDERS } from '@/utils/articleOrder'

// "Popular · Newest": the order control for an article list. The site's pill
// switch (2026-10-23, Sam: the same toggle as everywhere else; it was two
// words with a dot between). `surface` names the list for the
// headlines_sorted event.
export default function OrderToggle({
  value,
  onChange,
  surface,
  className = '',
}) {
  return (
    <span className={className}>
      <Pills
        label="Article order"
        size="sm"
        options={ORDERS}
        value={value}
        onChange={(id) => {
          if (id === value) return
          track('headlines_sorted', { order: id, surface })
          onChange(id)
        }}
      />
    </span>
  )
}
